export const SUPPORTED_LAYOUTS = ['column', 'row'];
export const SUPPORTED_TYPES = ['checkbox', 'radio', 'text'];

export default { SUPPORTED_LAYOUTS, SUPPORTED_TYPES };
